export default __webpack_public_path__ + "static/media/share_doc_link_screenshot.6ffd4000.png";